import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=c21de216&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=c21de216&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21de216",
  null
  
)

export default component.exports